import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_OFFER_IDS = createAsyncActionType("GET_OFFER_IDS");

export const CLEAR_OFFER_IDS = "CLEAR_OFFER_IDS";



// WEBPACK FOOTER //
// ./src/features/score-card/types/getOfferIdsTypes.js